import { render } from "./NewEnvironment.vue?vue&type=template&id=674d3202"
import script from "./NewEnvironment.vue?vue&type=script&lang=js"
export * from "./NewEnvironment.vue?vue&type=script&lang=js"

import "./NewEnvironment.vue?vue&type=style&index=0&id=674d3202&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__